import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Center,
  Select,
  Pagination,
  Checkbox,
  Tabs,
  Button,
  Loader,
} from "@mantine/core";
import {
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconCloudDown,
  IconTableExport,
} from "@tabler/icons-react";
import * as XLSX from 'xlsx';
import classes from "./AllItem.module.css";
// import DeleteStaff from "./DeleteStaff";
import { RowDataAllItem } from "./types";
import { props } from "./props";
import { CustomTable } from "../Table/CustomTable";
import { allItem } from "../types/RowDataTypes";
import { useFetchRowData } from "../hooks/useFetchRowData";
import { SearchBar } from "../SearchBar/SearchBar";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import { useLocation, useNavigate } from "react-router-dom";
import {
  showWarningAlert,
  showErrorAlert,
  showSuccessAlert
} from "../../helper/alerts";
import Header from "../static/Header";
import getAllItemTable from "../../DataDisplay/DataDisplayTable/AllItemTable";

// import { formatDD_MM_YYYY } from "../../helper/DateTime";

enum ColumnHeaderToFilterPair {
    ITEMNAME = "Item Name",
    DISPLAYNAME = "Display Name",
    BRAND = "Brand",
    PRICE = "Price",
}

const colFilter = ColumnHeaderToFilterPair;
const colFilters: { [key in ColumnHeaderToFilterPair]: string } = {
  [colFilter.ITEMNAME]: "itemName",
  [colFilter.DISPLAYNAME]: "displayName",
  [colFilter.BRAND]: "brand",
  [colFilter.PRICE]: "price",
};

function Th({ children, sortable, reversed, sorted, onSort }: props) {
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  let allowedSorts;

  allowedSorts = [
    colFilter.BRAND.toString().toLowerCase(),
    colFilter.PRICE.toString().toLowerCase(),
    // colFilter.FULLNAME.toString().toLowerCase(),
    // colFilter.CREATEDAT.toString().toLowerCase(),
    // colFilter.CONTACTNO.toString().toLowerCase(),
    // colFilter.EMAIL.toString().toLowerCase(),
    // colFilter.DOB.toString().toLowerCase(),
];
  const isCurrent =
    window.location.href.split("/")[5] === "all" ? true : false;
//   console.log("the children");
//   console.log(children);
//   console.log(allowedSorts);
//   console.log(allowedSorts.includes(children!!.toString().toLowerCase()));

  return children!! === "action" && !isCurrent ? (
    <></>
  ) : (
    <Table.Th className={`${classes.th} ${sortable ? classes.sortable : ""}`}>
      {allowedSorts.includes(children!!.toString().toLowerCase()) ? (
        <UnstyledButton onClick={onSort} className={classes.control}>
          <div className={classes.sortableHeader}>
            <Text fw={500} fz="sm">
              {children}
            </Text>
            <Center className={classes.icon}>
              <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </Center>
          </div>
        </UnstyledButton>
      ) : (
        <Text fw={500} fz="sm">
          {children}
        </Text>
      )}
    </Table.Th>
  );
}

// const initialData: RowDataAllItem[] = [
//   {
//     id: 0,
//     displayName: "",
//     itemName: "",
//     altItemLookup: "",
//     xItemId: "", 
//     xItemCode: "", 
//     xItemType: "", 
//     xItemModel: "", 
//     xDivision: "", 
//     brand: "", 
//     xCategory: "", 
//     cost: 0,
//     priceScheme: "",
//     description: "", 
//     images: "",
//     show: false, 
//     isReady: false,
//     deleted: false,
//     createdAt: "", 
//     updatedAt: "",
//     category: "",

//     isNewArrival: false,
//     isHotDeals: false,

//     action: "",
//   },
// ];

export function AllItem() {
  const axiosPrivate = useAxiosPrivate();
  const [isLoading, setIsLoading] = useState(false);
  const nav = useNavigate();
  const [search, setSearch] = useState<string>("");
  // const [sortedData, setSortedData] = useState(initialData);
  const [sortBy, setSortBy] = useState<keyof RowDataAllItem | null>(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [lastSyncTimestamp, setLastSyncTimestamp] = useState<string>("");
  const [disableSyncButton, setDisableSyncButton] = useState(false);

  const [tableStateChanged, setTableStateChanged] = useState(0);
  const changeTableState = () => {
    setTableStateChanged(Math.random() * Math.random());
  };

  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const resetPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
      return true;
    }
    return false;
  };

  const checkboxesFilter: JSX.Element[] = [];

  //Set allowed search filter checkbox to be shown
  const allowedFilters = [
    colFilters[colFilter.ITEMNAME],
    colFilters[colFilter.DISPLAYNAME],
    colFilters[colFilter.BRAND],
  ];

  for (const [key, value] of Object.entries(colFilters)) {
    if (allowedFilters.includes(value)) {
      const checkboxFilter: JSX.Element = (
        <Checkbox value={value} label={key} />
      );
      checkboxesFilter.push(checkboxFilter);
    }
  }

  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setSearch(input);
  };

  const location = useLocation();
  const fetchedData = useFetchRowData(
    itemsPerPage,
    currentPage,
    search,
    selectedFilters,
    tableStateChanged,
    sortBy ?? "createdAt",
    reverseSortDirection ? "DESC" : "ASC",
    allItem,
    getAllItemTable().create(),
    {
      current: location.pathname.split("/")[2] ?? "all",
    //   current: "unverified",
    },
  );

  const itemsOnPage = useRef(0);
  const totalRows = fetchedData.totalRows;
  const rowData: RowDataAllItem[] | null = fetchedData.data as RowDataAllItem[];
//   const isLoading: boolean = fetchedData.isLoading;
  const [RowDataDealer, setRowDataDealer] = useState<RowDataAllItem[] | null>(null);

  useEffect(() => {
    getXilnexSyncStatus();
    setRowDataDealer(rowData);
    itemsOnPage.current = fetchedData.itemsOnPage;
  }, [rowData]);

  // const [selectedRow, setSelectedRow] = useState<RowDataAllItem | null>(null);
  // const [isEditMode, setEditMode] = useState(false);
  // const handleEdit = (row: RowDataAllItem) => {
  //   setSelectedRow(row);

  //   // Check if the current page is "pass", then show the edit warning
  //   if (location.pathname.split("/")[2] === "all") {
  //     showEditWarning("Are you sure you want to edit this dealer?", setEditMode);
  //   } else {
  //     // If the page is not "pass", directly setEditMode to true
  //     setEditMode(true);
  //   }
  // };

  const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = startIndex + itemsPerPage;

  // const handleVerifyDealer = (
  //   editedData: RowDataAllItem,
  //   originalData: RowDataAllItem | null,
  //   action: string,
  //   remark: string,
  // ) => {
  //   if (originalData) {
  //     const paramsToUpdate = {
  //       // uid: originalData.uid,
  //       // action: action,
  //       // remark: remark,
  //     };

  //     axiosPrivate
  //       .post("/api/admin/dealer/verify-dealer", paramsToUpdate)
  //       .then((response) => {
  //         if (
  //           itemsOnPage.current === 1 &&
  //           currentPage !== 1 &&
  //           currentPage === Math.ceil(totalRows / itemsPerPage)
  //         )
  //           setCurrentPage((prev) => prev - 1);
  //         else changeTableState();
  //         showSuccessAlert("Dealer Successfully Updated");
  //       })
  //       .catch((error) => {
  //         showErrorAlert("An error has occured");
  //       });
  //   }

  //   setEditMode(false);
  // };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (value: number) => {
    setCurrentPage(1);
    setItemsPerPage(value);
  };

  // const isCurrent =
  //   location.pathname.split("/")[2] === "all" ? true : false;
  const rowsToMap = RowDataDealer ?? [];
  const rows = rowsToMap.map((row, index) => (
    <Table.Tr key={index}>
      <Table.Td>{startIndex + index + 1}</Table.Td>
      <Table.Td>{row.itemName}</Table.Td>
      <Table.Td>{row.displayName}</Table.Td>
      <Table.Td>{row.brand}</Table.Td>
      <Table.Td>{row.priceScheme ? row.priceScheme?.wholesalesPrice : ''}</Table.Td>
    </Table.Tr>
  ));

  const handleSelectPage = (selectedPage: number) => {
    if (selectedPage !== currentPage) setCurrentPage(selectedPage);
  };

  

  const handleTabChange = (val: string | null) => {
    val = val ?? "all";
    nav(`/store-item/${val}`);
    changeTableState();
  };

  const handleSorting = (val: any) => {
    setReverseSortDirection(!reverseSortDirection);
    setSortBy(val);
    changeTableState();
    // console.log("sorting");
    // console.log(val);
    // console.log(reverseSortDirection);
  };

  const handleXilnexSync = async () => {
    // Check for false positive of button enabled
    getXilnexSyncStatus();
    if (disableSyncButton) { 
      return showWarningAlert("Sync is already in progress!") 
    }
    try {
      setDisableSyncButton(true)
      setLastSyncTimestamp("Started Sync at " + new Date().toLocaleString())
      await axiosPrivate.get("/api/admin/items/sync", {
          headers: { "Content-Type": "multipart/form-data" },
        });
    } catch(error) {
        console.log("error " + error);
    } finally {
      // re-enable button and update sync status
      getXilnexSyncStatus();
      setDisableSyncButton(false);
    }
  };

  const getXilnexSyncStatus = async () => {
    await axiosPrivate
    .get(
        "/api/admin/items/sync-status",
        {
          headers: {
              "Content-Type": "multipart/form-data",
          },
        }
    )
    .then((res) => {
        console.log("Sync status response:", res.data.data);
        const syncDetails = new Date(res.data.data.createdAt).toLocaleString("en-MY", {
          timeZone: "Asia/Kuala_Lumpur",
          year: "numeric",
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
        if (res.data.data.logStatus) {
          setLastSyncTimestamp(syncDetails + " (" + res.data.data.logStatus + ")")
        } else {
          setLastSyncTimestamp(res.data.message)
        }
        setDisableSyncButton(res.data.data.logStatus === "IN PROGRESS" ? true : false);
    })
    .catch((error) => {
        console.log("error " + error);
    });
  }

  const handleExportTable = async () => {
    setIsLoading(true)
    try {
      const response = await axiosPrivate.get('/api/admin/items/export-all');

      const data = response.data.data;

      // Format the data for Excel
      const formattedData = data.map((row: any, index: number) => ({
        'No.': index + 1,
        'Item Name': row.itemName,
        'Display Name': row.displayName,
        'Brand': row.brand,
        'Price': row.priceScheme,
      }));

      // Create worksheet and workbook
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'All Orders');

      // Set column widths
      worksheet['!cols'] = [
        { wch: 5 },  // No.
        { wch: 100 }, // Item Name
        { wch: 100 }, // Display Name
        { wch: 15 }, // Brand
        { wch: 300 }, // Price
      ];

      // Generate filename with timestamp
      const timestamp = new Date().toLocaleDateString('en-CA', { 
        timeZone: 'Asia/Kuala_Lumpur' 
      });
      const filename = `all_items_${timestamp}.xlsx`;

      // Download file
      XLSX.writeFile(workbook, filename);
      
      showSuccessAlert('Export successful!');
    } catch (error) {
      console.error('Export error:', error);
      showErrorAlert('Failed to export data');
    }
    setIsLoading(false)
  };

  return (
    <div className={classes.orderContainer}>
    {isLoading && (
        <div className={classes.loadingOverlay}>
          <Loader size="xl" />
        </div>
      )}
      <ScrollArea className={classes.parentContainer}>
        <Header
          title={
            <div>
              <p>Store Item</p>
            </div>
          }
        />

        <div className={classes.searchBarContainer}>
          <SearchBar
            isLoading={isLoading}
            resetPage={resetPage}
            changeTableState={changeTableState}
            search={search}
            handleSearch={handleSearch}
            setShowFilterOptions={setShowFilterOptions}
            showFilterOptions={showFilterOptions}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            checkboxesFilter={checkboxesFilter}
          />
          <div style={{ display: "flex"}}>
            <div className={classes.titleBody}>
              <p>Last Sync: {lastSyncTimestamp? lastSyncTimestamp : "Loading..."}</p>
            </div>
            <div>
              <Button 
                onClick={handleXilnexSync} 
                className={disableSyncButton ? classes.disabledButton : classes.addButton} 
                disabled={disableSyncButton}
                style={{ marginRight: "12px" }}>
                <IconCloudDown className={classes.iconFileExport} />
                Sync
              </Button>
              <Button onClick={handleExportTable} className={disableSyncButton ?  classes.disabledButton : classes.exportButton} disabled={disableSyncButton}>
                <IconTableExport className={classes.iconFileExport} />
                Export Table
              </Button>
            </div>
          </div>
        </div>

        <Tabs
          defaultValue="all"
          color="blueviolet"
          variant="pills"
          onChange={(value) => {
            handleTabChange(value);
          }}
        >
          <ScrollArea
            w={
              window.innerWidth -
              document.getElementById("nav-bar")!!.getBoundingClientRect().width
            }
          >
            {/* <Tabs.Panel value="all"> */}
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            {/* </Tabs.Panel> */}

            {/* <Tabs.Panel value="case">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="cooler">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>


            <Tabs.Panel value="cpu">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="gpu">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="mobo">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="psu">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="ram">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="ssd">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel> */}

          </ScrollArea>

        </Tabs>

        <div className={classes.footerContainer}>
          <div className={classes.resultCount}>
            <Text>
              {`Showing `}
              <span style={{ fontWeight: "bold" }}>{startIndex + 1}</span>
              {`-`}
              <span style={{ fontWeight: "bold" }}>
                {Math.min(currentPage * itemsPerPage, totalRows)}
              </span>
              {` of `}
              <span style={{ fontWeight: "bold" }}>{totalRows}</span>
              {` results `}
            </Text>
          </div>

          <div className={classes.rightContainer}>
            <div className={classes.rowsPerPageSelector}>
              <Select
                placeholder="Rows per page"
                data={["10", "20", "50"]}
                value={itemsPerPage.toString()}
                onChange={(value) =>
                  handleRowsPerPageChange(parseInt(value as string, 10))
                }
              />
            </div>

            <div className={classes.paginationSelector}>
              <Pagination
                color="blueviolet"
                value={currentPage}
                total={Math.ceil(totalRows / itemsPerPage)}
                onNextPage={() => handlePageChange(currentPage + 1)}
                onPreviousPage={() => handlePageChange(currentPage - 1)}
                onChange={(value: number) => handleSelectPage(value)}
              />
            </div>
          </div>
        </div>

        {/*isEditMode && (
          <VerifyDealer
            isOpen={isEditMode}
            onClose={() => setEditMode(false)}
            onSaveChanges={(editedData, action, remark) =>
                handleVerifyDealer(editedData, selectedRow, action, remark)
            }
            initialData={selectedRow as RowDataDealer}
          />
        )*/}
      </ScrollArea>
    </div>
  );
}

export default AllItem;
